import { observable, action, makeObservable } from 'mobx'
import { types as t } from '@invisr/mobx-state-tree'
// import { Intent } from '@blueprintjs/core'
import errorToast from '../../utils/error-toast'
import crudActions from './crud-actions'
import fetch from '../../utils/fetch'

interface TwilioConfig {
  dbKey: string,
  defaultNumber: string,
}

async function twilioRequest(config: TwilioConfig, endpoint, method, data) {
  const resp = await fetch(`/api/datasource/${config.dbKey}/${endpoint}`, {
    method: method,
    headers: { 'Content-Type': 'application/json' },
    body: data && JSON.stringify(data)
  })
  const res = await resp.json()

  if (res.message) {
    errorToast('Twilio Error. ', res.errorMessage || res.message)
  } else {
    return res
  }
  
}

class TwilioProvider {
  isLoading = false
  config: TwilioConfig
  data = {}

  constructor (config?: TwilioConfig) {
    makeObservable(this, {
      isLoading: observable,
      data: observable,
      setIsLoading: action,
      setIsLoadingOff: action
    })

    this.config = config
  }

  setIsLoading = () => {
    this.isLoading = true
  }

  setIsLoadingOff = () => {
    this.isLoading = false
  }

  query = context => Promise.resolve()

  messages = async filter => twilioRequest(this.config, 'messages', 'POST', filter)


  /**
   * 
   * @param data { body, to, from, mediaUrl? }
   */
  sendSms = async (data: { body, to, from, mediaUrl }) => {
    try {
      data.from = data.from || this.config.defaultNumber 
      return twilioRequest(this.config, 'sendSMS', 'POST', data)
    } catch (err) {
      errorToast('Twilio Error. ', err)
      console.log(err)
    }
  }
}

export default t
  .model('TwilioConfig', {
    type: t.optional(t.string, 'Twilio'),
    defaultNumber: t.optional(t.string, '')
  })
  .views(self => ({
    get provider () {
      return TwilioProvider
    },
    fieldPath (node) {
      return node.meta && node.meta.fieldPath
    },
    labels () {
      const p = new TwilioProvider()
      const childNodes = Object.keys(p)
        .filter(k => typeof p[k] === 'function')
        .map(f => ({
          key: f,
          label: f,
          secondaryLabel: 'FUNCTION',
          meta: {
            fieldPath: f
          }
        }))
      return {
        key: (self as any).id as string,
        label: (self as any).name as string,
        childNodes: [
          {
            key: 'methods',
            label: 'Methods',
            childNodes
          },
          {
            key: 'data',
            label: 'Data',
            childNodes: []
          }
        ]
      }
    }
  }))
  .actions(crudActions)
